import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

import { EmployeesList } from "~/components/employees/employees-list";
import { Skeleton } from "~/components/ui/skeleton";

export const Route = createFileRoute("/_authenticated/employees/")({
  component: EmployeesPage,
  pendingComponent: () => <Skeleton className="h-96 w-full" />,
});

function EmployeesPage() {
  return (
    <Suspense fallback={<Skeleton className="h-96 w-full" />}>
      <EmployeesList />
    </Suspense>
  );
}
